<button mat-icon-button mat-dialog-close class="close">
  <mat-icon aria-label="Close shopping cart">close</mat-icon>
</button>

<mat-dialog-content>
  <p class="mt-3 text-center">
    <ng-container i18n="Confirmation message|Confirmation dialog when the user clicks “Add to cart”"
      >Your item was added to the shopping cart.</ng-container
    >
  </p>
</mat-dialog-content>

<mat-dialog-actions>
  <div class="container">
    <div class="row">
      <div class="col-12 col-md-6 pb-2">
        <button mat-button class="dialog-close" cdkFocusInitial (click)="dialogRef.close()">
          <ng-container
            i18n="Caption of “Continue booking” button|Confirmation dialog when the user clicks “Add to cart”"
            >Continue booking</ng-container
          >
        </button>
      </div>

      <div class="col-12 col-md-6 pb-2">
        <button mat-button class="dialog-next" (click)="navigateToCart()" test-id="checkout-button">
          <ng-container i18n="Caption of “Checkout” button|Confirmation dialog when the user clicks “Add to cart”"
            >Checkout</ng-container
          >
        </button>
      </div>
    </div>
  </div>
</mat-dialog-actions>
